import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { optionsChannels, optionsChannelsFlows, optionsObject } from '../constants/data.constants';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/forms/icon.component';
import Title from '../../../../components/forms/titles.component';
import CheckboxCards from '../../../../components/forms/advance-radio-3.component';
import Select from 'react-select';
import InvalidFeedback from '../../../../components/forms/invalid-feedback.component';

function Stepper4({ onValidationChange }: { onValidationChange: (isValid: boolean) => void }) {
  const { t } = useTranslation();
  const { control, watch } = useFormContext();

  const { objects, channelFlows, defaultChannel, channelsAvailable } = watch();

  const filteredOptionsChannels = optionsChannels.filter((option: any) => {
    if (option.value === 'wa') return channelsAvailable.includes('whatsapp');
    if (option.value === 'sms') return channelsAvailable.includes('sms');
    if (option.value === 'mail') return channelsAvailable.includes('mail');
    if (option.value === 'rcs') return channelsAvailable.includes('rcs_conversational');
    if (option.value === 'email') return channelsAvailable.includes('email');
    return false;
  });

  const stepper4Valid =
    Array.isArray(channelFlows) && channelFlows.length > 0 && !!objects && !!defaultChannel;

  useEffect(() => {
    onValidationChange(stepper4Valid);
  }, [stepper4Valid]);

  useEffect(() => {
    onValidationChange(stepper4Valid);
  }, [stepper4Valid]);

  return (
    <>
      <div className="text-left mb-3">
        <Title
          icon="ki-send"
          title={'Canal de envío'}
          subtitle={'Ve las diferentes configuraciones necesarias de tu canal.'}
          type="info"
        />
      </div>
      <div className="alert alert-dismissible bg-light-primary border border-primary d-flex border-dashed flex-column flex-sm-row p-5 mb-10 animate-fadeInUp animate-delay-1">
        <Icon icon="bi bi-stars" size="fs-2hx" type="primary" />
        <div className="d-flex flex-column pe-0 pe-sm-10 ms-5">
          <h5 className="mb-1 text-primary fw-bolder fs-3 mb-3">
            Análisis de archivo base cargado.
          </h5>
          <span>
            Vamos a revisar cada número de tu archivo y elegir el mejor canal de envío. Si el número
            no tiene historial, usaremos el canal predeterminado que elijas a continuación.
          </span>
        </div>
      </div>
      <div className="row mb-3">
        <div className="fv-row  mb-5 z-index-3">
          <div className="d-flex align-items-center mb-3">
            <span className="symbol me-e6 symbol-label"></span>
            <div className="d-flex flex-column">
              <span className="fw-bolder fs-3 required">Objetivo de campaña</span>
            </div>
          </div>
          <Controller
            control={control}
            name="objects"
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <Select
                  options={optionsObject}
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? t('general.no-options', { inputValue }) : t('general.no-options')
                  }
                  className={error ? 'form-select-custom is-invalid' : 'form-select-custom'}
                  classNamePrefix="form-select-custom"
                  placeholder={'Selecciona objetivo'}
                  onChange={(
                    selectedOption: {
                      value: string;
                      label: string;
                    } | null
                  ) => {
                    onChange(selectedOption ? selectedOption.value : null);
                  }}
                  value={
                    optionsObject.find(
                      (option: { value: string; label: string }) => option.value === value
                    ) || null
                  }
                />
                <InvalidFeedback error={error} />
              </>
            )}
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="d-flex align-items-center mb-3">
          <span className="symbol me-e6 symbol-label"></span>
          <div className="d-flex flex-column">
            <span className="fw-bolder fs-3 required">Canales a utilizar</span>
            <span className="fs-6">Selecciona los canales que deses.</span>
          </div>
        </div>
        <Controller
          control={control}
          name="channelFlows"
          rules={{
            required: 'Para poder procesar tu campaña es necesario registrar un canal'
          }}
          render={({ field, fieldState: { error } }) =>
            filteredOptionsChannels.length > 0 ? (
              <CheckboxCards {...field} options={filteredOptionsChannels} errors={error} />
            ) : (
              <div className="text-center w-100 py-5">
                <img
                  src="/assets/media/illustrations/undraw/no-find.svg"
                  alt="No se encontraron canales"
                  style={{ maxWidth: 300, margin: '0 auto', display: 'block' }}
                />
                <p className="mt-4 fs-4 text-muted fw-bold">No tienes canales habilitados.</p>
              </div>
            )
          }
        />
      </div>
      <div className="row mb-3">
        <div className="fv-row  mb-5 z-index-3">
          <div className="d-flex align-items-center mb-3">
            <span className="symbol me-e6 symbol-label"></span>
            <div className="d-flex flex-column">
              <span className="fw-bolder fs-3 required">Canal predeterminado</span>
            </div>
          </div>
          <Controller
            control={control}
            name="defaultChannel"
            rules={{ required: true }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <Select
                  options={optionsChannelsFlows}
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? t('general.no-options', { inputValue }) : t('general.no-options')
                  }
                  className={error ? 'form-select-custom is-invalid' : 'form-select-custom'}
                  classNamePrefix="form-select-custom"
                  placeholder={'Selecciona canal predeterminado'}
                  onChange={(
                    selectedOption: {
                      value: string;
                      label: string;
                    } | null
                  ) => {
                    onChange(selectedOption ? selectedOption.value : null);
                  }}
                  value={
                    optionsChannelsFlows.find(
                      (option: { value: string; label: string }) => option.value === value
                    ) || null
                  }
                />
                <InvalidFeedback error={error} />
              </>
            )}
          />
        </div>
      </div>
    </>
  );
}

export default Stepper4;
